import Vue from 'vue'
import Vuex from 'vuex'
import state from '@/vuex/state.coffee'
import actions from '@/vuex/actions.coffee'
import mutations from '@/vuex/mutations.coffee'
import getters from '@/vuex/getters.coffee'

Vue.use Vuex

export default new Vuex.Store( 
    state: state
    mutations: mutations
    actions: actions
    getters: getters
    strict: process.env.NODE_ENV != 'production'
  )


// WEBPACK FOOTER //
// ./src/vuex/index.coffee